<div class="list-page" style="max-width: 1200px">
  <app-asiakas-otsikko otsikko="Selaa toistuvia laskuja, Lemonaidissa näkyvät laskut"></app-asiakas-otsikko>

  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div style="padding: 10px; margin-bottom: 20px; max-width: 600px; position: relative" class="mat-elevation-z2">
      <span style="font-size: 10px; position: absolute; top: 3px; right: 5px" class="light-gray-text">(Vain devaajat)</span>
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
        Toistuvat laskut (Lemonaid): <a [href]="toistuvatLaskutEncodedUriObservable | async" target="_BLANK">{{ toistuvatLaskutUriObservable | async }}</a>
      </div>
    </div>
  }

  @if (lataa()) {
    <div class="loading">
      {{ 'toistuvat.ladataan' | translate | async }}
    </div>
  }

  @if (!lataa()) {
    <div>
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let rivi" (click)="$event.stopPropagation()">
            <button mat-icon-button (click)="toggleRow(rivi)">
              <mat-icon>{{ expandedElement === rivi ? 'remove' : 'add' }}</mat-icon>
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="asiakasNimi">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'toistuvat.asiakas' | translate | async }}</th>
          <td mat-cell *matCellDef="let rivi">{{ rivi.asiakasNimi }}</td>
        </ng-container>
        <ng-container matColumnDef="lahetysFrekvenssi">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'toistuvat.lahetetaan' | translate | async }}</th>
          <td mat-cell *matCellDef="let rivi">{{ rivi.lahetysFrekvenssi }}</td>
        </ng-container>
        <ng-container matColumnDef="ensimmainenLaskuPvm">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'toistuvat.ensimmainen-lasku-pvm' | translate | async }}</th>
          <td mat-cell *matCellDef="let rivi">{{ rivi.ensimmainenLaskuPvm | date: 'dd.MM.yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="viimeinenLaskuPvm">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'toistuvat.viimeinen-lasku-pvm' | translate | async }}</th>
          <td mat-cell *matCellDef="let rivi">{{ rivi.viimeinenLaskuPvm ? (rivi.viimeinenLaskuPvm | date: 'dd.MM.yyyy') : '-' }}</td>
        </ng-container>
        <ng-container matColumnDef="lahetyksia">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'toistuvat.lahetyksia' | translate | async }}</th>
          <td mat-cell *matCellDef="let rivi">{{ rivi.lahetyksia }}{{ rivi.yhteensaLahetyksia ? '/' + rivi.yhteensaLahetyksia : '' }}</td>
        </ng-container>
        <ng-container matColumnDef="summa">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'toistuvat.summa' | translate | async }}</th>
          <td mat-cell *matCellDef="let rivi">{{ rivi.summa | currency: 'EUR' }}</td>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let rivi" [attr.colspan]="displayedColumns.length">
            <div [@detailExpand]="rivi === expandedElement ? 'expanded' : 'collapsed'" style="overflow: hidden">
              <div style="padding: 1em">
                <h3 class="light-blue-text" style="margin-top: 0.5em">{{ 'toistuvat.lahetetyt-laskut' | translate | async }} ({{ rivi.lahetetytLaskut?.length || 0 }})</h3>
                @if (rivi.ladataanLahetettyjaTietoja) {
                  <div style="text-align: center; padding: 2em">
                    <mat-spinner diameter="40" style="margin: 0 auto"></mat-spinner>
                  </div>
                }
                @if (rivi.lahetetytLaskut && rivi.lahetetytLaskut.length > 0 && !rivi.ladataanLahetettyjaTietoja) {
                  <table style="width: 100%">
                    <thead>
                      <tr>
                        <th>{{ 'laskut.numero' | translate | async }}</th>
                        <th>{{ 'laskut.laskun-pvm' | translate | async }}</th>
                        <th>{{ 'laskut.erapaiva' | translate | async }}</th>
                        <th>{{ 'laskut.summa' | translate | async }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (lahetty of rivi.lahetetytLaskut; track lahetty) {
                        <tr (click)="katseleLahetettyaLaskua(rivi, lahetty.avain)" style="cursor: pointer">
                          <td>{{ lahetty.nro }}</td>
                          <td>{{ lahetty.p | lnumberpvm | async }}</td>
                          <td>{{ lahetty.erap | lnumberpvm | async }}</td>
                          <td>{{ lahetty.summa | currency: 'EUR' }}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                }
                @if (!rivi.lahetetytLaskut || (rivi.lahetetytLaskut.length === 0 && !rivi.ladataanLahetettyjaTietoja)) {
                  <p>{{ 'toistuvat.ei-lahetettuja-laskuja' | translate | async }}</p>
                }
              </div>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="katseleLaskua(row)" style="cursor: pointer"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length" style="text-align: center; padding: 2em">
            {{ 'toistuvat.ei-toistuvia-laskuja' | translate | async }}
          </td>
        </tr>
      </table>
      <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
    </div>
  }
</div>
